import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import OfferManagementContext from '../../../../context/offerManagement.context';
import CreateNoOrLowCostEmi from '../createNoOrLowCostEmi/createNoOrLowCostEmi';
import { useState } from 'react';
import LoadingLogoPage from '../../../loadingPage/loadingPage';
import { customToast } from '../../../../reusableComponents/customToaster/customToast';
import { useAuth } from '../../../../context/API_Client';
import { isEmpty } from '../../../utils/utils';

const EditNoOrLowCostEmi = () => {
    const location = useLocation();
    const { getEmiOfferById } = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const { type, data } = location.state?.editData || {};
    const { code } = data || {};
    const { setOfferFieldData, setOfferDetailsById, offerDetailsById } = useContext(OfferManagementContext);

    useEffect(() => {
        getEmiOfferById(
            code,
            (data) => {
                setIsLoading(false);
                setOfferDetailsById(data);
            },
            (error) => {
                customToast("error", "high", error);
            }
        );
    }, []);

    useEffect(() => {
        if (isEmpty(offerDetailsById)) return

        const startDate = new Date(offerDetailsById?.criteria?.startDate);
        const endDate = new Date(offerDetailsById?.criteria?.endDate);
        setOfferFieldData(prev => ({
            ...prev,
            minAmount: offerDetailsById?.criteria?.minMoney?.amount,
            maxAmount: offerDetailsById?.criteria?.maxMoney?.amount,
            offerTitle: offerDetailsById?.title,
            offerDescription: offerDetailsById?.description,
            offerStartDate: startDate,
            offerEndDate: endDate,
            selectedEmiOption: offerDetailsById?.criteria?.applicableTo?.paymentMethods[0]?.brand,
            selectedIssuer: offerDetailsById?.criteria?.applicableTo?.paymentMethods[0]?.issuer,
            applicableOffer: offerDetailsById?.criteria?.applicableTo?.paymentMethods,
        }));
    }, [offerDetailsById])

    return (
        <>
            {isLoading ? (
                <div className="content-wrapper whiteBg">
                    <section className="content offerManagementLoadingSection">
                        <LoadingLogoPage />
                    </section>
                </div>
            ) : <div><CreateNoOrLowCostEmi type={type} /></div>
            }
        </>
    )
}

export default EditNoOrLowCostEmi